const loginReducer = (state = {}, action) => {
    switch (action.type) {
        case  "addLoginData" : 
            return action.payload
        default:
            return state

    }
};

export default loginReducer;